var map = {
	"./konfigurator_bagazniki.svg": "9fd1",
	"./konfigurator_blotniki.svg": "342d",
	"./konfigurator_foteliki.svg": "dd75",
	"./konfigurator_kobieta.svg": "9b63",
	"./konfigurator_koszyki.svg": "db89",
	"./konfigurator_mezczyzna.svg": "8b39",
	"./konfigurator_podporka.svg": "06ef",
	"./konfigurator_przyczepka.svg": "eb80",
	"./konfigurator_torby.svg": "77b9",
	"./konfigurator_unisex.svg": "ecb5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f57b";